import { createDeferred } from 'utils/create-deferred';

interface AnimateOptions {
    duration: number;
    easing?: (x: number) => number;
    onProgress: (progress: number) => void;
}

const animate = (options: AnimateOptions) => {
    let start = 0;
    const { duration, onProgress, easing } = options;

    const { promise, resolve } = createDeferred();

    const inner = (time: number) => {
        start ||= time;
        const fraction = (time - start) / duration;
        if (fraction >= 0 && fraction <= 1) {
            const progress = easing ? easing(fraction) : fraction;
            onProgress(progress);
            window.requestAnimationFrame(inner);
        } else {
            resolve();
        }
    };

    window.requestAnimationFrame(inner);
    return promise;
};

animate.easing = {
    easeInOutCubic: (x: number) => (x < 0.5 ? 4 * Math.pow(x, 3) : 1 - Math.pow(-2 * x + 2, 3) / 2),
    easeInOutQuart: (x: number) => (x < 0.5 ? 8 * Math.pow(x, 4) : 1 - Math.pow(-2 * x + 2, 4) / 2),
    easeInOutQuint: (x: number) => (x < 0.5 ? 16 * Math.pow(x, 5) : 1 - Math.pow(-2 * x + 2, 5) / 2)
};

export default animate;
